/*
  Cart size prompt.
  Pieces added from the homepage cards carry a hidden _pick_size property and are added at
  their first available size. In the cart drawer and on the cart page this script shows a
  "Choose your size" dropdown for those lines and pauses checkout until each one is chosen.
  If a line cannot be found in the page, checkout is left alone rather than blocked.
*/
(function () {
  if (window.__nwSizePrompt) return;
  window.__nwSizePrompt = true;

  var FLAG = '_pick_size';
  var products = {};
  var busy = false;
  var timer = null;

  var css = document.createElement('style');
  css.textContent =
    '.nwsz{margin-top:1rem}' +
    '.nwsz label{display:block;margin-bottom:.4rem;font-size:1.2rem;font-weight:600}' +
    '.nwsz select{width:100%;min-height:4rem;padding:0 1rem;border:.1rem solid rgb(var(--color-foreground));border-radius:var(--inputs-radius);background:rgb(var(--color-background));color:rgb(var(--color-foreground));font:inherit;font-size:1.4rem}' +
    '.nwsz-note{margin:1rem 0 0;font-size:1.3rem;text-align:center;color:rgb(var(--color-foreground))}' +
    'button[data-nwsz]{opacity:.5;cursor:not-allowed}';
  document.head.appendChild(css);

  function getProduct(handle) {
    if (!products[handle]) {
      products[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js').then(function (r) { return r.json(); });
    }
    return products[handle];
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function nodesFor(index) {
    var out = [];
    var a = document.getElementById('CartDrawer-Item-' + index);
    var b = document.getElementById('CartItem-' + index);
    if (a) out.push(a);
    if (b) out.push(b);
    return out;
  }

  function sizeIndex(product) {
    var names = (product.options || []).map(function (o) { return String(typeof o === 'string' ? o : o.name).toLowerCase(); });
    return names.indexOf('size');
  }

  function swap(item, variantId, select) {
    select.disabled = true;
    var drawer = document.querySelector('cart-drawer');
    var onCartPage = /\/cart\/?$/.test(window.location.pathname);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: item.quantity }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || 'Could not add that size');
        var body = { id: item.key, quantity: 0 };
        if (drawer && !onCartPage) {
          body.sections = 'cart-drawer,cart-icon-bubble';
          body.sections_url = window.location.pathname;
        }
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (drawer && !onCartPage && cart.sections) {
          drawer.renderContents(cart);
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        window.location.reload();
      });
  }

  function build(item, product, nodes) {
    var si = sizeIndex(product);
    if (si < 0) return false;
    var current = item.variant_options || [];
    var choices = product.variants.filter(function (v) {
      if (!v.available) return false;
      return v.options.every(function (val, i) { return i === si || val === current[i]; });
    });
    if (!choices.length) return false;

    nodes.forEach(function (node) {
      if (node.querySelector('.nwsz')) return;
      var uid = 'nwsz-' + String(item.key).replace(/[^a-z0-9]/gi, '') + '-' + node.id;
      var box = document.createElement('div');
      box.className = 'nwsz';
      var label = document.createElement('label');
      label.setAttribute('for', uid);
      label.textContent = 'Choose your size';
      var select = document.createElement('select');
      select.id = uid;
      var first = document.createElement('option');
      first.value = '';
      first.textContent = 'Choose size';
      select.appendChild(first);
      choices.forEach(function (v) {
        var opt = document.createElement('option');
        opt.value = v.id;
        opt.textContent = v.options[si];
        select.appendChild(opt);
      });
      select.addEventListener('change', function () {
        if (select.value) swap(item, select.value, select);
      });
      box.appendChild(label);
      box.appendChild(select);
      (node.querySelector('.cart-item__details') || node).appendChild(box);
    });
    return true;
  }

  function setCheckout(block) {
    document.querySelectorAll('button[name="checkout"]').forEach(function (btn) {
      var note = btn.nextElementSibling && btn.nextElementSibling.classList.contains('nwsz-note') ? btn.nextElementSibling : null;
      if (block) {
        if (!btn.hasAttribute('data-nwsz')) {
          btn.setAttribute('disabled', 'disabled');
          btn.setAttribute('data-nwsz', '1');
        }
        if (!note) {
          var p = document.createElement('p');
          p.className = 'nwsz-note';
          p.textContent = 'Choose a size for each piece to continue to checkout.';
          btn.insertAdjacentElement('afterend', p);
        }
      } else {
        if (btn.hasAttribute('data-nwsz')) {
          btn.removeAttribute('disabled');
          btn.removeAttribute('data-nwsz');
        }
        if (note) note.remove();
      }
    });
  }

  function apply() {
    if (busy) return;
    if (!document.querySelector('[id^="CartDrawer-Item-"], [id^="CartItem-"]') && !document.querySelector('button[data-nwsz]')) return;
    busy = true;
    getCart()
      .then(function (cart) {
        var jobs = [];
        cart.items.forEach(function (it, i) {
          if (it.properties && it.properties[FLAG]) jobs.push({ item: it, index: i + 1 });
        });
        return Promise.all(
          jobs.map(function (j) {
            var nodes = nodesFor(j.index);
            if (!nodes.length) return Promise.resolve(false);
            return getProduct(j.item.handle).then(function (p) { return build(j.item, p, nodes); });
          })
        ).then(function (results) {
          setCheckout(results.length > 0 && results.every(Boolean));
        });
      })
      .catch(function () { setCheckout(false); })
      .then(function () { busy = false; });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(apply, 200);
  }

  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  schedule();
})();